import CryptoJS from "crypto-js";

// Function to encrypt data
const encryptData = (data: object): string => {
  const jsonData = JSON.stringify(data); // Convert object to string
  return CryptoJS.AES.encrypt(jsonData, process.env.REACT_APP_SECRET || "SecretP4yl0ad").toString();
};

export default encryptData;